var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtMoneySmall = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 70,
    viewBox: "0 0 77 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d3fj57uima",
    d: "M0 0h77v51.8H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 9.1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bh4tezysab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d3fj57uima"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#bh4tezysab)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F6C760",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.854 13.655c-.194 0-.228.283-.039.328.41.096.792.09.828-.115.03-.173-.381-.213-.79-.213zM46.547 10.663c.02.184.279.201.324.021.173-.678.181-1.432-.151-1.468-.28-.03-.241.815-.173 1.447zM48.549 12.214c-.16.09-.075.337.107.31.686-.107 1.376-.395 1.278-.717-.083-.274-.838.096-1.385.407zM48.253 10.962c-.147.152.072.383.229.239.198-.182.312-.366.222-.48-.077-.096-.26.042-.45.24z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.334 7.08)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.12 15.469C2.462 13.11 12.23 1.289 12.514.2c.36-1.38 8.574 4.773 8.065 6.422-.51 1.65-11.756 14.872-12.979 14.853-2.095-.03-8.558-4.921-7.48-6.006z",
    fill: "#3EB58A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.634 15.418c1.751-2.247 10.702-12.48 11.202-13.737.458-1.148 6.881 3.829 6.439 5.26C18.833 8.374 8.522 20.417 7.382 20.39c-1.817-.04-6.353-4.193-5.747-4.972h-.001z",
    stroke: "#1B5B44",
    strokeWidth: 0.526
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.994 13.845c-.792 0-1.482-.354-1.893-.97a2.15 2.15 0 0 1-.303-1.651c.117-.56.498-1.38 1.642-2.106a2.15 2.15 0 0 1 1.151-.328c.994 0 1.962.645 2.248 1.501.187.559.147 1.2-.114 1.805a2.754 2.754 0 0 1-1.242 1.366 3.273 3.273 0 0 1-1.487.384h-.002v-.001z",
    fill: "#87C9A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.59 8.874c.961 0 1.893.62 2.168 1.443.181.539.141 1.159-.113 1.745a2.673 2.673 0 0 1-1.204 1.325 3.207 3.207 0 0 1-1.449.375c-.38 0-.733-.081-1.047-.24a2.041 2.041 0 0 1-.777-.693 2.072 2.072 0 0 1-.291-1.588c.077-.365.242-.72.493-1.055.277-.368.65-.704 1.113-.997a2.067 2.067 0 0 1 1.107-.315m0-.167c-.41 0-.822.105-1.195.34-1.845 1.17-2.063 2.828-1.364 3.874.436.653 1.151 1.007 1.963 1.007.486 0 1.008-.126 1.524-.392 1.15-.592 1.802-2.07 1.398-3.272-.302-.901-1.302-1.557-2.326-1.557z",
    fill: "#1B5B44"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1B5B44",
    fillRule: "nonzero",
    transform: "rotate(-50.07 13.858 7.115)",
    cx: 13.858,
    cy: 7.115,
    rx: 1.271,
    ry: 1.634
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1B5B44",
    fillRule: "nonzero",
    transform: "rotate(-50.07 6.756 15.487)",
    cx: 6.756,
    cy: 15.487,
    rx: 1.187,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92 16.52s3.087-3.212 3.188-3.852c.102-.64-.236-1.008-.236-1.008l-3.375 3.934.423.925zM15.85 11.712c-.22-.787-.522-1.107-.257-1.526.266-.419 3.091-4.5 3.24-4.302.148.197.583.748.44 1.057-.142.308-3.222 4.52-3.222 4.52l-.2.25z",
    fill: "#1B5B44",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.318 0h77v51.8h-77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.952 23.17c.221-.207 3.097-2.527 3.96-2.331.45.102.285 3.25-2.707 4.202-1.173.373-1.932-1.815-1.932-1.815l.68-.056z",
    fill: "#191937",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.053 28.36c-1.225 2.48-2.774 5.074-4.004 5.345-3.306.45-6.176 1.046-10.494-.137-1.183-.325-2.474-.783-3.915-1.413a53.211 53.211 0 0 1-2.157-.983 61.653 61.653 0 0 1-2.016-1.02c-5.15-2.72-10.093-6.163-16.245-9.74l.25-1.216 2.192-10.589c6.008 6.558 11.47 10.828 18.35 16.328l1.272 1.018.759.61c.25.186.498.324.747.413.588.21 1.177.151 1.802-.186 1.402-.755 5.611-3.21 6.65-3.814l.072-.042c1.165-.659 2.916-1.733 4.208-2.157.941-.19.415.858.174 1.645-.417 1.07-1.147 1.43-2.378 2.524-.831.704-1.539 1.811-1.476 2.768.033.506.318.916.839 1.312 1.333 1.014 1.874-.805 2.8-1.984.785.276 1.867 1.126 2.571 1.321v-.002h-.001z",
    fill: "#EFA88F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.48 25.776c-.143.27-.338.558-.48.813-.88 1.482-2.518 3.623-3.803 4.856-4.988-1.688-10.428-5.467-18.208-9.892l2.775-13.416c7.345 6.865 15.567 13.608 19.45 17.044.165.154.41.324.269.595h-.003z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.328 24.374a3.535 3.535 0 0 1-.314.561c-.187.286-.424.606-.705.961-1.505 1.915-3.263 3.702-4.894 5.28-.318.161-8.09-3.617-15.441-9.569l.011-.054.486-2.357 2.484-12.01c5.612 5.16 13.353 11.639 18.57 16.654.01.06-.159.43-.202.537h.003l.002-.003z",
    fill: "#9A5238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v51.8H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.274 37.482c-5.017-1.833-6.335-3.531-6.084-3.997.251-.467.535-.376 1.268-.179.735.197 2.755.776 5.07 1.916 2.317 1.138 3.949-.146 4.065-.202 1.96-1.203 4.306-1.602 4.306-1.602l2.683 5.23s-9.537-.517-11.31-1.165l.002-.001z",
    fill: "#DD9280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.161 38.872c-5.163-1.354-8.491-2.584-8.467-3.115.034-.758 2.342-.741 3.09-.614.747.126 3.04.182 5.45 1.1 2.41.916 3.89-.162 4-.228.11-.066 4.141-1.998 4.141-1.998l3.153 4.957s-9.543.377-11.368-.102h.001z",
    fill: "#E89F89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.514 38.03c.79.789 7.502 1.845 9.326 2.1l.218.03c1.35.192 5.915-1.146 8.193 1.313.436.47.809 1.11 1.155 1.963.223.548.435 1.183.647 1.916.065.229.13.469.198.717.828 3.123 1.68 7.796 3.138 14.636l.064.3.03.01c.493.14 6.845 1.872 8.377-.704.385-.647.466-1.563.078-2.842-1.455-4.787-2.995-9.888-4.236-13.332a38.354 38.354 0 0 0-1.007-2.562c-.086-.19-.167-.366-.247-.524-1.125-2.251-1.583-3.67-2.486-5.416-.154-.298-.348-.642-.59-.924-1.632-1.899-6.553-3.586-8.1-4.15-1.64-1.144-4.207-1.643-4.729-.718-.382.676.967 2.048 2.154 2.55.896.379 1.858 1.135 2.523 1.817.083.085.161.168.235.25.117.131.221.257.308.373.026 1.03-1.764 1.8-3.078 2.294-1.14.428-2.561.03-4.036.12a5.556 5.556 0 0 0-.683.08c-1.067.195-3.986-.683-5.202-.54a8.029 8.029 0 0 0-.402.06c-1.122.188-2.391.637-1.843 1.186h-.005v-.003z",
    fill: "#EDA994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.838 40.131.219.03c1.35.192 5.915-1.145 8.193 1.313.436.47.808 1.111 1.155 1.963.222.549.435 1.184.646 1.916l.36-.072s-.252-2.225-2.237-4.33c-1.466-1.557-6.249-1.34-8.336-.82z",
    fill: "#1F1F39",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.322 62.95c.396.782 1.346.881 2.503.566 1.634-.445 3.687-1.711 5.203-3.05 1.368-1.207 2.3-2.473 2.091-3.245-.465-1.73-4.096-10.14-5.913-14.263-.533-1.209-.91-2.05-1.005-2.247-.074-.152-.36-.224-.79-.231a7.682 7.682 0 0 0-1.008.062c-1.85.217-4.63.955-5.968 1.627a3.882 3.882 0 0 0-.314.173c-.328.2-.502.39-.452.553.194.632.414 1.426.655 2.334 1.07 4.036 2.539 10.302 3.778 14.385l.094.31c.408 1.317.788 2.38 1.118 3.03l.006-.002.002-.002z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.317 68.007c.55.888 1.77.918 3.197.456 1.738-.561 3.787-1.852 5.317-3.211 1.476-1.311 2.47-2.686 2.242-3.535-.659-2.453-6.552-18.37-7.267-18.703-.113-.051-.32-.067-.6-.054-.22.011-.485.04-.785.083-.35.052-.749.124-1.175.212a57.115 57.115 0 0 0-5.848 1.573c-.154.052-.297.1-.43.148-.262.094-.48.18-.642.252-.21.095-.322.167-.312.21 1.287 5.136 4.108 19.037 6.3 22.57h.003v-.001z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.317 68.007c.55.888 1.77.918 3.197.456a9537.42 9537.42 0 0 0-1.69-4.945c-2.083-6.1-4.951-14.479-6.425-18.692-.54-1.544-.893-2.527-.95-2.636l-.01-.02a3.882 3.882 0 0 0-.314.174c-.328.2-.502.39-.452.552.194.632.414 1.427.655 2.335-.21.095-.322.167-.312.21 1.286 5.136 4.107 19.037 6.3 22.57v-.003l.001-.001z",
    fill: "#1F1F39",
    opacity: 0.08
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.555 33.568c-1.183-.325-2.474-.783-3.915-1.413a53.211 53.211 0 0 1-2.157-.983l-.034.034a3.37 3.37 0 0 1-.255.238c-.14.112-.944-.205-2.232-.838-.027.02-.53.56-.547.568-.318.162-8.09-3.617-15.441-9.568l.011-.055.486-2.356c3.076 2.576 10.463 7.143 16.46 10.495.665.373 1.313.73 1.936 1.068 2.425 1.316 4.475 2.338 5.687 2.81h.001z",
    fill: "#1F1F39",
    fillRule: "nonzero",
    opacity: 0.08
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtMoneySmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-money-small.79674033e14ff7f292e09e35c07efca0.svg";